<template>
  <div class="producttype">
    <div
      class="mobile-tablet-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile-tablet_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="true"
        :speed="2000"
        :autoplay-speed="5000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/product_slide01.jpg') center center / cover;"
        >
          <div class="slide-overlay">
            <img src="img/chinese_passion.png" alt width="48" />
          </div>
        </div>
        <div
          class="slide"
          style="background: url('./img/product_slide02.jpg') center center / cover;"
        >
          <div class="slide-overlay">
            <img src="img/chinese_balance.png" alt width="48" />
          </div>
        </div>
        <div
          class="slide"
          style="background: url('./img/product_slide03.jpg') center center / cover;"
        >
          <div class="slide-overlay">
            <img src="img/chinese_precision2.png" alt width="48" />
          </div>
        </div>
      </agile>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/product_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
    </div>
    <div class="mobile-unpad">
      <div class="container mobile-padding mobile-bg-blue" style="text-align:left;">
        <div class="mobile-tablet-show" style="padding-top:40px;"></div>
        <div class="columns">
          <div class="column" style="padding-bottom:0;">
            <span class="title-size">{{$t('body.product_title1')}}</span>
            <span
              class="title-size"
              style="font-weight:900;font-family:AvenirBold;"
            >{{$t('body.product_title2')}}</span>
            <!-- <p>{{$t('body.product_p1')}}</p> -->
            <div class="subtitlebodyblue">
              <span>{{$t('body.product_p1')}}</span>
              ( CaCO
              <sub style="position: relative;
    left: -5px;">3</sub>)
              <span>{{$t('body.product_p1_2')}}</span>
            </div>
          </div>
        </div>
              <div
        v-if="this.$i18n.locale == 'cn'"
        class="container middle-separator line-bottom-right-120 mobile-hide">
        QUALITY
      </div>
      <div
        v-if="this.$i18n.locale == 'en'"
        class="container middle-separator line-bottom-right mobile-hide">
          <img style="position: relative; top: 6px;" src="img/chinese_quality.jpg" alt width="55" />
      </div>

      </div>

      <div class="container mobile-padding" style="text-align:left;">
        <div class="mobile-tablet-hide" style="margin-top:45px;margin-bottom:16px;"></div>
        <div class="mobile-tablet-show" style="padding-top:24px;"></div>
        <div class="columns">
          <div class="column" style="padding-bottom:7px; font-size:48px;">
            <span class="title-size">{{$t('body.product_type_title1')}}</span>
          </div>
        </div>
      </div>
      <u-animate-container>
        <u-animate
          name="fadeInUp"
          delay="0s"
          duration="2s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <!-- mobile-tablet -->

          <div class="mobile-tablet-show">
            <div
              style="
            height:240px;
            border: solid white 4px;
          background-image:url('./img/products_producttype02.jpg');
          background-position: center;
          background-size: cover;
            "
            ></div>
            <div style="text-align:left;border: solid white 4px;">
              <div style="font-size:20px;">{{$t('body.product_type_s1_title')}}</div>
              <div>
                <div
                  style="font-size:16px; color:#6d6e70;padding-bottom:8px;"
                >{{$t('body.product_type_s1_p1')}}</div>
              </div>
              <div
                style="
            height:240px;
            border: solid white 4px;
          background-image:url('./img/products_producttype01.jpg');
          background-position: center;
          background-size: cover;
            "
              ></div>
              <div style="text-align:left;border: solid white 4px;">
                <div style="font-size:20px;">{{$t('body.product_type_s2_title')}}</div>
                <div>
                  <div
                    style="font-size:16px; color:#6d6e70;padding-bottom:8px;"
                  >{{$t('body.product_type_s2_p1')}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- mobile-tablet -->
          <div class="container mobile-tablet-hide">
            <div class="columns">
              <div
                @mouseenter="hilightTableIn"
                @mouseleave="hilightTableOut"
                class="column hilight-table"
                style="height:500px;
          border: solid white 4px;
          background-image:url('./img/products_producttype02.jpg');
          background-position: center;
          background-size: cover;
          "
              >
                <div>
                  <div
                    style="font-size:32px; font-weight:600;line-height: 1;"
                  >{{$t('body.product_type_s1_title')}}</div>
                  <div>
                    <div
                      style="font-size:20px; line-height:1.2; text-align:left;"
                    >{{$t('body.product_type_s1_p1')}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div
                @mouseenter="hilightTableIn"
                @mouseleave="hilightTableOut"
                class="column hilight-table"
                style="height:500px;
          border: solid white 4px;
          background-image:url('./img/products_producttype01.jpg');
          background-position: center;
          background-size: cover;
          "
              >
                <div>
                  <div
                    style="font-size:32px; font-weight:600;line-height: 1;"
                  >{{$t('body.product_type_s2_title')}}</div>
                  <div>
                    <div
                      style="font-size:20px; line-height:1.2; text-align:left;"
                    >{{$t('body.product_type_s2_p1')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </u-animate>
      </u-animate-container>
    </div>

    <div style="position:relative;top:200px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>
<script>
export default {
  name: "producttype",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
    // document.styleSheets[0].addRule(
    //   "#logodef01.container.middle-separator.line-bottom-right::after",
    //   "width: 165px;"
    // );
    // document.styleSheets[0].addRule(
    //   "#logodef02.container.middle-separator.line-bottom-right::after",
    //   "width: 240px;"
    // );
    // document.styleSheets[0].addRule(
    //   "#logodef03.container.middle-separator.line-bottom-right::after",
    //   "width: 175px;"
    // );
  },
  methods: {
    hilightTableIn(e) {
      let el = e.target;
      el.classList.toggle("over");
    },
    hilightTableOut(e) {
      let el = e.target;
      el.classList.toggle("over");
    }
  }
};
</script>

<style lang="scss" scoped>
.slide {
  height: 400px;
}
// .middle-separator-right {
//   color: #aaa;
//   padding-bottom: 3px;
//   text-align: right;
//   line-height: 1.7;
//   margin-top: 16px;
//   margin-bottom: 16px;
// }

// .line-bottom-right {
//   border-bottom: 1px solid #aaa;
//   position: relative;
// }

// .line-bottom-right:after {
//   content: "";
//   display: block;

//   width: 120px;
//   height: 8px;
//   background: #aaa;
//   position: absolute;
//   bottom: 0;
//   right: 0;
// }
.slide-overlay {
  font-size: 40px;
  line-height: 1;
  text-align: right;
  color: white;
  border-right: white solid 1px;
  position: relative;
  padding: 250px 8px 0;
  right: 150px;
  height: 350px;
}
.slide-overlay::before {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-right: 4px;
  right: 0;
}

// .logodef {
//   width: 100%;
//   height: inherit;
//   background: #00354cc4;
//   color: white;
//   position: absolute;
//   z-index: 2;
//   padding: 16px;
//   opacity: 1;
//   text-align: left;
//   transition: all 100ms ease-in-out;
// }
// .logodef.hide {
//   width: 100%;
//   height: inherit;
//   background: #00354cc4;
//   position: absolute;
//   z-index: 2;
//   padding: 16px;
//   opacity: 0;
//   text-align: left;
//   transition: all 100ms ease-in-out;
// }

.column {
  padding: 0;
}

.hilight-table {
  background-color: #00354c00;
  background-blend-mode: multiply;
  padding: 24px;
  color: white;
  font-size: 24px;
  div {
    width: 80%;
    opacity: 0;
    transition: all 300ms ease-in-out;
  }
  transition: all 300ms ease-in-out;
}
.hilight-table.over {
  background-color: #00354cc4;
  background-blend-mode: multiply;
  div {
    width: 80%;
    opacity: 1;
    transition: all 300ms ease-in-out;
  }
  transition: all 300ms ease-in-out;
}
</style>
